<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Left Panel: Requisition Info -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Requisition Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="Requisition Type"
                      v-model="type"
                      :items="requisitionType"
                      item-title="label"
                      item-value="value"
                      density="compact"
                      variant="outlined"
                      clearable
                        hide-details
                      :error-messages="errors.type"
                      @update:model-value="changerequisitionType" 
                      required
                    />
                  </v-col>

                  <v-col cols="12" v-if="!isBulkRequisition">
                    <v-autocomplete
                      v-if="!isBulkRequisition"
                      label="sale Orders"
                      v-model="sale_order_master_id"
                      :items="pendingSaleOrderListForProduction"
                      item-title="code"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                        hide-details
                      :error-messages="errors.sale_order_master_id"
                      @update:model-value="changeSaleOrder" 
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-date-input
                      label="Requisition Date"
                      v-model="requisition_date"
                      variant="outlined"
                      density="compact"
                      clearable
                      prepend-icon=""
                      hide-details
                      :error-messages="errors.requisition_date"
                      required
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      label="Remarks"
                      v-model="remarks"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.remarks"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Right Panel: Requisition Details -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Requisition Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row v-if="isBulkRequisition" class="pt-2 justify-center">
                  <v-col cols="8">
                      <v-autocomplete 
                          label="Search Product Name" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4"
                          v-model="product_id.value.value"
                          :items="getProductMapList"
                          :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" 
                          item-value="product_id"
                          :error-messages="product_id.errorMessage.value"
                          @update:model-value="addCart" 
                          @keydown.enter="addCart"
                          autocomplete="off" 
                          clearable>
                      </v-autocomplete>
                  </v-col>
              </v-row>


              <v-row class="pt-0">
                  <v-col cols="12">
                     
                    <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">SL</th>
                          <th class="text-center" style="width: 10%">Code</th>
                          <th class="text-left" style="width: 25%">Product Name</th>
                          <th class="text-center" style="width: 10%">Unit</th>
                          <th class="text-left" style="width: 20%">Quantity</th>
                          <th class="text-right" style="width: 5%">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <template v-for="(item, index) in cart" :key="index">
                          <!-- Main row -->
                          <tr @click="toggleRow(index)" style="cursor: pointer; background: #0000003B;">
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td class="text-left py-1">{{ item.product_code }}</td>
                            <td class="text-left py-1">{{ item.product_name }}</td>
                            <td class="text-center py-1">{{ item.unit_name }}</td>
                            <td class="text-left py-1"> 
                              <v-text-field 
                                :reverse="false" 
                                controlVariant="stacked" 
                                style="width: 80px" 
                                label="" 
                                :hideInput="false" 
                                :inset="false" 
                                :min="1" 
                                type="number" 
                                density="compact" 
                                variant="outlined" 
                                bg-color="grey-lighten-4" 
                                v-model="item.quantity" 
                                hide-details :error="item.quantity < 1" 
                                :error-messages="item.quantity < 1 ? 'Quantity must be greater than 0' : ''"
                                @click.stop > 
                              </v-text-field> 
                            </td>
                            <td class="text-center py-1">
                              <v-btn icon color="red" variant="tonal" @click.stop="removeRow(index)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </tr>

                          <!-- Expandable row -->
                          <tr v-if="expandedRow === index">
                            <td colspan="6" class="pa-5 bg-grey-lighten-4">
                              <v-expand-transition>
                                <div v-if="item.template_items">
                                  <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">
                                    <thead>
                                      <tr>
                                        <th class="text-center" style="width: 5%">SL</th>
                                        <th class="text-center" style="width: 10%">Code</th>
                                        <th class="text-left" style="width: 20%">Raw Product Name</th>
                                        <th class="text-center" style="width: 10%">Unit</th>
                                        <th class="text-left" style="width: 10%">Qty</th>
                                        <th class="text-left" style="width: 10%">Total Qty </th>
                                        <th class="text-left" style="width: 20%">Process Loss % </th>
                                        <th class="text-left" style="width: 10%">Loss Qty</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(templateItem, rawIndex) in item.template_items" :key="rawIndex">
                                        <td class="text-center py-1">{{ rawIndex + 1 }}</td>
                                        <td class="text-left py-1">{{ templateItem?.raw_product?.code }}</td>
                                        <td class="text-left py-1">{{ templateItem?.raw_product?.name }}</td>
                                        <td class="text-center py-1">{{ templateItem?.raw_product?.unit?.name }}</td>
                                        <td class="text-left py-1">{{ templateItem.quantity }}</td>
                                        <td class="text-left py-1">{{ templateItem.quantity * item.quantity }}</td>
                                        <td class="text-left py-1">{{ templateItem.process_loss_percent }}</td>
                                        <td class="text-left py-1">{{ ((templateItem.quantity * item.quantity) * (templateItem.process_loss_percent / 100)).toFixed(2) }}</td>
                                      </tr>
                                    </tbody>
                                  </v-table>
                                </div>
                              </v-expand-transition>
                            </td>
                          </tr>
                        </template>

                        <tr v-if="cart.length === 0 && !loading">
                          <td colspan="6" class="text-center text-red">You have no item</td>
                        </tr>
                      </tbody>
                    </v-table>
                      
                  </v-col>
              </v-row>

                <v-divider class="my-2"></v-divider>

                <v-card-actions>
                  <v-row class="pt-2">
                    <v-col cols="8"></v-col>
                    <v-col cols="4" class="d-flex justify-end">
                      <v-btn
                        class="bg-grey-darken-1 me-2"
                        variant="flat"
                        :loading="loading"
                        @click="() => submitRequisition(0)"
                      >
                        Draft
                      </v-btn>
                      <v-btn
                        class="bg-primary"
                        variant="flat"
                        :loading="loading"
                        @click="() => submitRequisition(1)"
                      >
                        {{ isEdit ? "Update" : "Save" }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
  import { ref, computed, onMounted, nextTick } from "vue";
  import { useStore } from "vuex";
  import { useForm, useField } from "vee-validate";
  import * as yup from "yup";
  import { toast } from "vue3-toastify";
  import { useRouter, useRoute } from "vue-router";

  const store = useStore();
  const router = useRouter();
  const route = useRoute();

  /* UI state */
  const panel = ref([0]);
  const panel2 = ref([0]);
  const loading = ref(false);
  const isEdit = ref(false);
  const requisitionId = ref(null);
  const isBulkRequisition = ref(true);

  /* Validation */
  const { handleSubmit, setErrors, errors } = useForm({
    validationSchema: yup.object({
      type: yup.string().required(),
      requisition_date: yup.date().required(),
      
      sale_order_master_id: yup.number().nullable().when('type', {
        is: 'sale_order',
        then: (schema) => schema.required('Sale Order is required'),
        otherwise: (schema) => schema.nullable(),
      }),
      remarks: yup.string().nullable(),
      product_id: yup.number().nullable(),
    }),
  });

  /* Fields */
  const { value: type } = useField("type", null, { initialValue: "bulk" });
  const { value: sale_order_master_id } = useField("sale_order_master_id");
  const { value: requisition_date } = useField("requisition_date");
  const { value: remarks } = useField("remarks");
  const product_id = useField("product_id");

  /* Data */
  const cart = ref([]);

  const requisitionType = [
    { value: "bulk", label: "Bulk" },
    { value: "sale_order", label: "Sale Order" },
  ];

  const getProductMapList = computed(() => store.getters.getProductMapList || []);
  const pendingSaleOrderListForProduction = computed(
    () => store.getters.getPendingSaleOrderListForProduction || []
  );

  /* Functions */

  function changerequisitionType() {
    isBulkRequisition.value = type.value === "bulk";
    cart.value = [];
  }

  function addCart() {
    const id = product_id.value.value;

    if (!id) return toast.error("Select product");

    if (cart.value.find(p => p.product_id == id)) {
      return toast.error("Already added");
    }

    let product = getProductMapList.value.find(p => p.id == id)?.product;

    cart.value.push({
      product_id: id,
      product_name: product.name,
      product_code: product.code,
      unit_name: product.unit?.name,
      quantity: 1,
      template_items: product.template?.items,
    });

    nextTick(() => (product_id.value.value = null));
  }

  const expandedRow = ref(null); 
  const toggleRow = (index) => { 
    expandedRow.value = expandedRow.value === index ? null : index; 
  };

  function removeRow(i) {
    cart.value.splice(i, 1);
  }

  // function changeSaleOrder() {
  //   let order = pendingSaleOrderListForProduction.value.find(
  //     o => o.id == sale_order_master_id.value
  //   );

  //   if (!order) return;

  //   cart.value = order.details.map(item => ({
  //     product_id: item.product_id,
  //     product_name: item.product?.name,
  //     product_code: item.product?.code,
  //     unit_name: item.product?.unit?.name,
  //     quantity: item.quantity,
  //   }));
  // }

  function changeSaleOrder(){ 
    const order = pendingSaleOrderListForProduction.value.find(item => item.id == sale_order_master_id.value ); 
    if(!order) return; 
    cart.value = order.details.map(item => ({ 
      product_id: item.product_id, 
      product_name: item.product?.name, 
      product_code: item.product?.code, 
      unit_name: item.product?.unit?.name, 
      quantity: item.quantity, 
      template_items: item.product?.template?.items, 
    })); 
  }

  async function loadRequesition(id){
      try {

      const response = await store.dispatch("getRawMetarialRequisitionById", id);
      const data = response.data;

      type.value = data.type;
      sale_order_master_id.value = data.sale_order_master_id;
      requisition_date.value = data.requisition_date;
      remarks.value = data.remarks;
      isBulkRequisition.value = type.value === 'bulk';

      cart.value = data.details.map(item => ({
          product_id: item.product_id,
          product_name: item.product?.name,
          product_code: item.product?.code,
          unit_name: item.product?.unit?.name,
          quantity: item.quantity,
          template_items: item.product?.template?.items,
      }));

  } catch (error) {

      console.error(error);
      toast.error("Failed to load production!");

  }
  }


  /* Submit */

  const submitRequisition = (status) => {
    handleSubmit(async (values) => {
      loading.value = true;

      try {
        const payload = {
          ...values,
          id: isEdit.value ? requisitionId.value : null,
          status,
          cart: cart.value,
        };

        if (isEdit.value) {
          await store.dispatch("updateRawMetarialRequisition", payload);
          toast.success("Updated");
        } else {
          await store.dispatch("saveRawMetarialRequisition", payload);
          toast.success("Saved");
        }

        router.push({ name: "production-requisition-list" });

      } catch (error) {
        let message = 'Something went wrong'; 
        if (error?.response?.data) { 
          const data = error.response.data; 
          if (data.errors) { 
            setErrors(error.response.data.errors); 
            message = Object.values(data.errors).flat().join('\n'); 
          } else if (data.message) { 
            message = data.message; 
          } 
        } else if (error.message) { 
          message = error.message; 
        } 
        toast.error(message);
      }

      loading.value = false;
    })();
  };

  /* Load */

  onMounted(async () => {
    loading.value = true;

    await store.dispatch("getProductMapList");
    await store.dispatch("getPendingSaleOrderListForProduction");
      if(route.query.id) {
          requisitionId.value = route.query.id;
          isEdit.value = true;
          await loadRequesition(requisitionId.value);
      }

    loading.value = false;
  });
</script>